import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useSession } from '@/contexts/LitSessionProvider';
import { useOnboarding } from '@/components/home/mobile/Onboarding/useOnboarding';
import useERC20Balance from '@/hooks/portfolio/useERC20Balance';
import useReferralCode from '../onboarding/useReferralCode';
import useAppDetails from '../utilities/useAppDetails';
const useAuthGuard = (TwoFa = true) => {
  const router = useRouter();
  const {
    PKP,
    clearLitSession,
    decryptedWallets
  } = useSession();
  const {
    runAuthFlow,
    MFAInfo,
    setMFAInfo,
    groupLoading,
    loading,
    googleLoader,
    appleLoader,
    ethWalletLoader,
    mfaLoading,
    progressBar
  } = useOnboarding();
  const {
    data: assetData,
    isLoading: loadingBalances
  } = useERC20Balance({
    evmAddresses: [PKP?.additionalEthAddress],
    solanaAddresses: [PKP?.solanaAddress]
  });
  const {
    referralData,
    handleUseReferralCode,
    cloudData,
    loadingQueries
  } = useReferralCode();
  const {
    referralUrlCode,
    setReferralUrlCode
  } = useAppDetails();
  const isLoading = loading || groupLoading || loadingQueries || googleLoader || appleLoader || ethWalletLoader;
  useEffect(() => {
    if (router.query.code) {
      let code = router.query.code?.toString();
      code = code?.includes('?') ? code.split('?')[0] : code;
      if (code && code.length === 6) {
        setReferralUrlCode(code);
      } else {
        // setReferralUrlCode('');
      }
    }
  }, [router.query.code]);
  const showAuthLoader = isLoading;
  const shouldOnboard = !cloudData?.data?.user_id || !cloudData?.data?.eth_address || !decryptedWallets?.length;
  const showReferralInput = referralData && referralData.codes === null && cloudData;
  const hasUsername = Boolean(cloudData?.data?.username);
  const showTwoFaModal = TwoFa && MFAInfo?.presentMFAInfo?.authId && !MFAInfo?.sessionSigs;
  const zerobalance = assetData?.totalUsdValue === 0 || isNaN(assetData?.totalUsdValue);
  const showDeposit = PKP?.ethAddress && zerobalance && router.pathname !== '/settings/account' && router.pathname !== '/settings' && router.pathname !== '/refer';
  const isUserWithFunds = !shouldOnboard && !showReferralInput && hasUsername && !showTwoFaModal && !showDeposit;
  return {
    showBalancesLoader: loadingBalances,
    showAuthLoader,
    shouldOnboard,
    isUserWithFunds,
    showReferralInput,
    showTwoFaModal,
    showDeposit,
    mfaLoading,
    runAuthFlow,
    setMFAInfo,
    MFAInfo,
    handleUseReferralCode,
    referralUrlCode,
    clearLitSession,
    zerobalance,
    PKP,
    hasUsername,
    cloudData,
    progressBar
  };
};
export default useAuthGuard;